import { render, staticRenderFns } from "./detection-category-selector.vue?vue&type=template&id=76f76535&"
import script from "./detection-category-selector.vue?vue&type=script&lang=js&"
export * from "./detection-category-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports